import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ActualiteService } from '../shared';
import { ActualiteComponent } from './_list/actualite.component';
import { ActualiteDetailComponent } from './_detail/actualite-detail.component';

@NgModule({
  imports: [ CommonModule, RouterModule ],
  declarations: [
  	ActualiteComponent,
  	ActualiteDetailComponent,
  ],
  providers: [ ActualiteService ]
})
export class ActualiteModule { }



// WEBPACK FOOTER //
// ./src/app/actualite/actualite.module.ts